import React from 'react';
import { connect } from 'react-redux';

import Typography from 'material-ui/Typography';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Switch from 'material-ui/Switch';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Input, { InputLabel } from 'material-ui/Input';

import * as CalendarState from '../../../state/reducer/calendar/calendar';
import Console from '../../../lib/debug';
import DialogFactory from '../../factory/DialogFactory';

class CalendarAutoPublish extends React.Component {
    state = {
        team: { ...this.props.team } || {}
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            team: { ...nextProps.team } || {}
        });
    }

    handleSave() {
        CalendarState.openAutoPublishSettings();
        CalendarState.updateTeamOptions(this.state.team);
    }

    handleClose() {
        CalendarState.openAutoPublishSettings();
    }

    handleChangePubDays(event) {
        this.handleChange('pub_days', event.target.value);
    }

    handleChangePubTime(event) {
        this.handleChange('pub_time', event.target.value);
    }

    toggleAutoPublishEnabled() {
        if (this.state.team.pub_days === null) this.handleChange('pub_days', 0);
        if (this.state.team.pub_time === null) this.handleChange('pub_time', 0);

        let enabled = this.state.team.pub_enabled ? 0 : 1;
        this.handleChange('pub_enabled', enabled);
    }

    handleChange(attribute, value) {
        let team = this.state.team;
        team[attribute] = value;
        this.setState(team);
    }

    publishDateSelect() {
        return (
            <FormControl className="input">
                <InputLabel htmlFor="select-day">
                    Publish My Workouts
                </InputLabel>
                <Select
                    value={this.state.team.pub_days || 0}
                    className="select-full-width"
                    onChange={this.handleChangePubDays.bind(this)}
                    input={<Input id="select-day" />}
                    disabled={!this.state.team.pub_enabled}
                >
                    <MenuItem key={0} value={0}>
                        Same Day
                    </MenuItem>
                    <MenuItem key={1} value={1}>
                        Previous Day
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                        2 Days Before
                    </MenuItem>
                    <MenuItem key={3} value={3}>
                        3 Days Before
                    </MenuItem>
                    <MenuItem key={4} value={4}>
                        4 Days Before
                    </MenuItem>
                    <MenuItem key={5} value={5}>
                        5 Days Before
                    </MenuItem>
                    <MenuItem key={6} value={6}>
                        6 Days Before
                    </MenuItem>
                    <MenuItem key={7} value={7}>
                        1 Week Before
                    </MenuItem>
                </Select>
            </FormControl>
        );
    }

    publishTimeSelect() {
        return (
            <FormControl className="input">
                <InputLabel htmlFor="select-time">Publish Time</InputLabel>
                <Select
                    value={this.state.team.pub_time || 0}
                    className="select-full-width"
                    onChange={this.handleChangePubTime.bind(this)}
                    input={<Input id="select-time" />}
                    disabled={!this.state.team.pub_enabled}
                >
                    <MenuItem key={0} value={0}>
                        12:00AM
                    </MenuItem>
                    <MenuItem key={1} value={1}>
                        1:00AM
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                        2:00AM
                    </MenuItem>
                    <MenuItem key={3} value={3}>
                        3:00AM
                    </MenuItem>
                    <MenuItem key={4} value={4}>
                        4:00AM
                    </MenuItem>
                    <MenuItem key={5} value={5}>
                        5:00AM
                    </MenuItem>
                    <MenuItem key={6} value={6}>
                        6:00AM
                    </MenuItem>
                    <MenuItem key={7} value={7}>
                        7:00AM
                    </MenuItem>
                    <MenuItem key={8} value={8}>
                        8:00AM
                    </MenuItem>
                    <MenuItem key={9} value={9}>
                        9:00AM
                    </MenuItem>
                    <MenuItem key={10} value={10}>
                        10:00AM
                    </MenuItem>
                    <MenuItem key={11} value={11}>
                        11:00AM
                    </MenuItem>
                    <MenuItem key={12} value={12}>
                        12:00AM
                    </MenuItem>
                    <MenuItem key={13} value={13}>
                        1:00PM
                    </MenuItem>
                    <MenuItem key={14} value={14}>
                        2:00PM
                    </MenuItem>
                    <MenuItem key={15} value={15}>
                        3:00PM
                    </MenuItem>
                    <MenuItem key={16} value={16}>
                        4:00PM
                    </MenuItem>
                    <MenuItem key={17} value={17}>
                        5:00PM
                    </MenuItem>
                    <MenuItem key={18} value={18}>
                        6:00PM
                    </MenuItem>
                    <MenuItem key={19} value={19}>
                        7:00PM
                    </MenuItem>
                    <MenuItem key={20} value={20}>
                        8:00PM
                    </MenuItem>
                    <MenuItem key={21} value={21}>
                        9:00PM
                    </MenuItem>
                    <MenuItem key={22} value={22}>
                        10:00PM
                    </MenuItem>
                    <MenuItem key={23} value={23}>
                        11:00PM
                    </MenuItem>
                </Select>
            </FormControl>
        );
    }

    publishDateTimeSelect() {
        return (
            <form>
                {this.publishDateSelect()}
                <br />
                {this.publishTimeSelect()}
            </form>
        );
    }

    enablePublishSwitch() {
        return (
            <FormControlLabel
                control={
                    <Switch
                        checked={!!this.state.team.pub_enabled}
                        onChange={this.toggleAutoPublishEnabled.bind(this)}
                        value="pub_enabled"
                        color="primary"
                    />
                }
                label="Auto-Publish Enabled"
            />
        );
    }

    dialogContent() {
        return (
            <div>
                <p className="copy">
                    Use these settings to manage the auto-publishing options for
                    this calendar.
                </p>
                <p className="copy">
                    Once enabled, sessions will auto-publish and be available to
                    your athletes on the time and day selected.
                </p>
                {this.enablePublishSwitch()}
                <br />
                {this.publishDateTimeSelect()}
                <br />
                <small>Central timezone (America/Chicago)</small>
            </div>
        );
    }

    render() {
        Console.render('CalendarAutoPublishDialog');
        return (
            <DialogFactory
                enabled={this.props.enabled}
                handleClose={this.handleClose.bind(this)}
                handleSave={this.handleSave.bind(this)}
                header="Auto-Publish Options"
                text={this.dialogContent()}
                cancelButtonTitle="Cancel"
                saveButtonTitle="Done"
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        enabled: state.calendar.uiTree.autoPublishSettingsOpen,
        team: state.calendar.infoTree.team
    };
};

CalendarAutoPublish = connect(mapStateToProps)(CalendarAutoPublish);

export default CalendarAutoPublish;



// WEBPACK FOOTER //
// ./src/view/calendar/calendar-dialogs/CalendarAutoPublishDialog.jsx